/* eslint-disable react/prop-types */
import React from 'react';

/**
 * Top-5 Tags panel (030 US1 / FR-006) on the shared au-panel design system. Keeps
 * the distinctive heart-rate tag mix — the five most-used session tags (count desc,
 * then name, as returned by the server) — and adds each tag's percentage share of
 * Total Sessions. Denominator is Total Sessions for the active filters; shows "—"
 * when Total Sessions is 0 (no divide-by-zero). Conveyed by text + value, tabular
 * numerals, never colour alone.
 *
 * Props: { tags: [{ tag_name, tag_count }], totalSessions: number }
 */
const n = (v) => Number(v || 0).toLocaleString();

const pctShare = (count, total) => {
  if (!total || Number(total) <= 0) return '—';
  return `${Math.round((Number(count || 0) / Number(total)) * 100)}%`;
};

const HeartRateTopTagsPanel = ({ tags = [], totalSessions = 0 }) => (
  <div className="au-panel hr-tags" data-testid="hr-top-tags">
    <div className="au-panel__head">
      <h4 className="au-panel__title">Top 5 Tags</h4>
    </div>
    {(!tags || tags.length === 0) ? (
      <div className="au-chart-empty" data-testid="hr-top-tags-empty">
        No tagged sessions in this range.
      </div>
    ) : (
      <ul className="hr-tags__list">
        {tags.map((tag, index) => (
          <li className="hr-tags__item" key={`${tag.tag_name}-${index}`}>
            <span className="hr-tags__name au-ellipsis">{tag.tag_name}</span>
            <span className="hr-tags__count tnum">{n(tag.tag_count)}</span>
            <span className="hr-tags__pct tnum" data-testid="hr-tag-pct">
              {pctShare(tag.tag_count, totalSessions)}
            </span>
          </li>
        ))}
      </ul>
    )}
  </div>
);

export default HeartRateTopTagsPanel;
